import type { FunctionComponent } from "react";
import React from "react";

import { Container, Description, IconWrapper, Title } from "./styles";

export type Props = {
  description: string;
  icon: React.ReactNode;
  isBackgroundActive?: boolean;
  title: string;
};

export const PlusItemCard: FunctionComponent<Props> = ({
  description,
  icon,
  isBackgroundActive,
  title,
}) => (
  <Container $isBackgroundActive={isBackgroundActive}>
    <IconWrapper>{icon}</IconWrapper>
    <Title>{title}</Title>
    <Description>{description}</Description>
  </Container>
);
PlusItemCard.displayName = "PlusItemCard";
